export default __webpack_public_path__ + "static/media/search.dd362093.svg";